// ABOUTME: Index route for /. Renders nothing — ChatLayout handles display.
// ABOUTME: Exists to register the route in the file-based route tree.

import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_chat/")({
  component: () => null,
});
